<template>
    <shared-schedules-list
            :allow-modifying="true"
            :breadcrumbs="breadcrumbs"
    />
</template>
<script>

    import SharedSchedulesList from '@/components/providers/schedule/SharedSchedulesList'
    import {mapMutations, mapState} from 'vuex'

    export default{
        components: {
            SharedSchedulesList
        },
        data(){
            return {
                breadcrumbs: [
                    {
                        text: 'Todas las Agendas',
                        disabled: true,
                        href: ''
                    }
                ],
            }
        },
        mounted(){},
        methods: {
            ...mapMutations(['showSnackBar'])
        },
        computed: {
            ...mapState(['currentProvider', 'currentBranchOffice'])
        },
        watch: {}
    }
</script>